module.exports = __webpack_public_path__ + "media/images/feature-2-7a297df7.png";